// extracted by mini-css-extract-plugin
module.exports = {"container":"descrizione-pacchetto-module--container--30M1V","description":"descrizione-pacchetto-module--description--3bNyu"};